import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { LocationStatusEnum } from '../../locations/enums/location-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function locationStatusToColor(status: LocationStatusEnum): string {
	switch (status) {
		case LocationStatusEnum.OPEN:
			return RecordColorEnum.GREEN;

		case LocationStatusEnum.CLOSED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
